export default class RegisterOutput {
  canLogin!: boolean;
}
